import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BuildingElementFunctionApiService, BuildingElementFunctionName, BuildingElementFunctionType, BuildingElementType} from '@cas-hub/acabim-common-client';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'acabim-admin-add-functional-properties',
    templateUrl: './add-functional-properties.component.html',
    styleUrls: ['./add-functional-properties.component.scss']
})
export class AddFunctionalPropertiesComponent implements OnInit {
    @Input() buildingGUID!: string;
    @Output() addFunction = new EventEmitter<boolean>();
    addForm: any;
    // @ts-ignore
    functionalTypes: { name: string, value: string }[] = [];
    functionalNames: { name: string, value: string }[] = [];
    userDefined = false;
    isLoading = false;

    constructor(private readonly buildingElementFunctionService: BuildingElementFunctionApiService) {
        this.functionalTypes = [];
        this.functionalNames = [];

        this.addForm = new FormGroup({
            functionalType: new FormControl(''),
            functionalName: new FormControl(''),
            userDefined: new FormControl(''),
            propertyValue: new FormControl(''),
            remarks: new FormControl('')
        });
        // tslint:disable-next-line:forin
        for (const buildingElementFunctionTypeKey in BuildingElementFunctionType) {
            const isValueProperty = parseInt(buildingElementFunctionTypeKey, 10) >= 0;
            if (!isValueProperty) {
                this.functionalTypes.push({name: buildingElementFunctionTypeKey, value: BuildingElementFunctionType[buildingElementFunctionTypeKey]});
            }
        }
        // tslint:disable-next-line:forin
        for (const buildingElementFunctionTypeKey in BuildingElementFunctionName) {
            const isValueProperty = parseInt(buildingElementFunctionTypeKey, 10) >= 0;
            if (!isValueProperty) {
                this.functionalNames.push({name: buildingElementFunctionTypeKey, value: BuildingElementFunctionName[buildingElementFunctionTypeKey]});
            }
        }
    }

    ngOnInit(): void {
        // tslint:disable-next-line:forin
        for (const buildingElementFunctionTypeKey in BuildingElementFunctionType) {
            console.log(buildingElementFunctionTypeKey);
        }
        console.log(Object.keys(BuildingElementFunctionType));
    }

    checkFunction() {
        console.log(this.addForm.getRawValue());
        this.userDefined = this.addForm.getRawValue().functionalName?.name === 'USERDEFINED';
    }

    onSubmit() {
        this.isLoading = true;
        if (this.userDefined) {
            this.buildingElementFunctionService.createFunction({
                // @ts-ignore
                predefinedName: BuildingElementFunctionName[this.addForm.getRawValue().functionalName?.name],
                // @ts-ignore
                predefinedType: BuildingElementFunctionType[this.addForm.getRawValue().functionalType?.name],
                remarks: this.addForm.getRawValue().remarks,
                userDefinedName: BuildingElementType.building,
                value: this.addForm.getRawValue().userDefined,
                buildingElementType: BuildingElementType.building,
                buildingElementGuid: this.buildingGUID
            }).subscribe(data => {
                this.isLoading = false;
                this.addFunction.emit(true);
            });
        } else {
            this.buildingElementFunctionService.createFunction({
                // @ts-ignore
                predefinedName: BuildingElementFunctionName[this.addForm.getRawValue().functionalName?.name],
                // @ts-ignore
                predefinedType: BuildingElementFunctionType[this.addForm.getRawValue().functionalType?.name],
                remarks: this.addForm.getRawValue().remarks,
                userDefinedName: '',
                value: this.addForm.getRawValue().propertyValue,
                buildingElementType: BuildingElementType.building,
                buildingElementGuid: this.buildingGUID
            }).subscribe(data => {
                this.isLoading = false;
                this.addForm.reset();
                this.addFunction.emit(true);
            });
        }

    }
}
